var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositiveThinking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m257.217 196.139h25.546c11.913 0 21.571 9.658 21.571 21.571v16.164c0 11.913-9.658 21.571-21.571 21.571h-25.546z",
    fill: "#ffb09e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.868 196.139h-25.546c-11.913 0-21.571 9.658-21.571 21.571v16.164c0 11.913 9.658 21.571 21.571 21.571h25.546z",
    fill: "#f89580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.43 80.157c0 25.476-11.881 48.165-30.4 62.843-11.324 8.97-17.693 22.802-17.693 37.254v19.055c0 13.688-11.086 24.774-24.774 24.774h-14.575c-13.688 0-24.774-11.086-24.774-24.774v-19.066c0-14.524-6.524-28.335-17.878-37.398-18.58-14.813-30.431-37.698-30.214-63.359.351-43.014 35.21-78.451 78.213-79.462 45.162-1.063 82.095 35.221 82.095 80.133z",
    fill: "#ffe177"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408.275 195.482c-4.276 0-7.742-3.466-7.742-7.742l.001-59.543c0-4.276 3.467-7.742 7.742-7.742 4.276 0 7.742 3.466 7.742 7.742l-.001 59.543c0 4.276-3.467 7.742-7.742 7.742z",
    fill: "#ffd15b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m418.599 223.897c-.991.124-2.003.186-3.035.186h-14.575c-13.688 0-24.774-11.086-24.774-24.774v-19.066c0-14.524-6.524-28.335-17.878-37.398-18.58-14.813-30.431-37.698-30.214-63.359.351-43.014 35.21-78.451 78.213-79.462 4.181-.103 8.289.124 12.294.64-39.081 5.058-69.532 38.627-69.862 78.822-.217 25.662 11.633 48.546 30.214 63.359 11.355 9.063 17.878 22.874 17.878 37.398v19.066c0 12.656 9.486 23.092 21.739 24.588z",
    fill: "#ffd15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.338 187.738v11.571c0 13.688-11.086 24.774-24.774 24.774h-14.575c-13.688 0-24.774-11.086-24.774-24.774v-11.571z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.599 223.897c-.991.124-2.003.186-3.035.186h-14.575c-13.688 0-24.774-11.086-24.774-24.774v-11.571h20.645v11.571c0 12.656 9.486 23.092 21.739 24.588z",
    fill: "#b3dafe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.519 443.982v68.015h-133.912l-18.273-10h-25.206l-20.649 10h-133.909v-68.015c0-18.198 11.571-34.394 28.789-40.288l73.057-24.981 12.834 7.038 6.03-13.488h90.528l7.442 10.488 11.419-4.038 73.05 24.982c17.228 5.893 28.8 22.089 28.8 40.287z",
    fill: "#8ac9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.25 385.75-54.924 17.944c-17.218 5.894-28.789 22.09-28.789 40.288v68.015h-30.967v-68.015c0-18.198 11.571-34.394 28.789-40.288l73.057-24.981z",
    fill: "#60b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.543 406.425-22.876 4.242-9.188 15.344 16.032 28.51h32.064l16.032-28.51-7.94-17.053z",
    fill: "#68748f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.127 426.011 16.031 28.511h-20.645l-16.03-28.511 9.184-15.344 22.877-4.238 24.123 2.529-13.8 3.778z",
    fill: "#5d6980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.511 454.521-16.032 57.479h64.128l-16.032-57.479z",
    fill: "#68748f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.158 454.522-16.031 57.475h-20.644l16.03-57.475z",
    fill: "#5d6980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.839 296.815v75.499l-45.295 34.105-45.295-34.105v-40.464l.031-35.035z",
    fill: "#ffb09e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.867 398.646-10.323 7.773-45.295-34.105v-40.464l.031-35.035h20.645l-.031 35.035v40.464z",
    fill: "#f89580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.839 296.815v58.559c-11.953 5.667-25.3 8.826-39.37 8.826h-11.86c-14.069 0-27.406-3.159-39.359-8.815v-23.535l.031-35.034h90.558z",
    fill: "#f89580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.868 157.559v114.255c0 39.624 32.121 71.745 71.745 71.745h11.859c39.624 0 71.745-32.121 71.745-71.745v-114.255c0-12.134-9.837-21.971-21.971-21.971h-111.406c-12.135 0-21.972 9.837-21.972 21.971z",
    fill: "#ffcebf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.867 343.421c-1.455.093-2.921.134-4.397.134h-11.86c-39.618 0-71.741-32.113-71.741-71.741v-94.254c0-12.139 9.837-21.977 21.977-21.977h20.645c-12.139 0-21.977 9.837-21.977 21.977v94.254c-.001 38.152 29.779 69.346 67.353 71.607z",
    fill: "#ffb09e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m156.116 244.086c-4.276 0-7.742-3.466-7.742-7.742v-10.162c0-4.276 3.466-7.742 7.742-7.742s7.742 3.466 7.742 7.742v10.162c0 4.276-3.466 7.742-7.742 7.742z",
    fill: "#68748f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m222.817 244.086c-4.276 0-7.742-3.466-7.742-7.742v-10.162c0-4.276 3.466-7.742 7.742-7.742s7.742 3.466 7.742 7.742v10.162c0 4.276-3.466 7.742-7.742 7.742z",
    fill: "#68748f"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m189.543 305.599c-14.975 0-27.157-12.183-27.157-27.157 0-4.276 3.466-7.742 7.742-7.742s7.742 3.466 7.742 7.742c0 6.437 5.237 11.674 11.674 11.674 6.436 0 11.673-5.237 11.673-11.674 0-4.276 3.466-7.742 7.742-7.742s7.742 3.466 7.742 7.742c-.001 14.974-12.184 27.157-27.158 27.157z",
    fill: "#f89580"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m85.06 480.224v31.773h-15.483v-31.773c0-4.273 3.468-7.742 7.742-7.742s7.741 3.469 7.741 7.742z",
    fill: "#60b7ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m309.512 480.224v31.773h-15.484v-31.773c0-4.273 3.458-7.742 7.742-7.742 4.273.001 7.742 3.469 7.742 7.742z",
    fill: "#60b7ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m144.248 372.315 45.295 34.105-53.478 32.673c-4.664 2.85-10.65-.507-10.65-5.973v-54.412z",
    fill: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.838 372.315-45.295 34.105 53.478 32.673c4.664 2.85 10.65-.507 10.65-5.973v-54.412z",
    fill: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m440.339 195.482h-64.128c-4.276 0-7.742-3.466-7.742-7.742s3.466-7.742 7.742-7.742h64.128c4.276 0 7.742 3.466 7.742 7.742s-3.466 7.742-7.742 7.742z",
    fill: "#eaf6ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m440.34 63.825h-15.909v-15.909c0-8.922-7.233-16.155-16.155-16.155s-16.155 7.233-16.155 16.155v15.909h-15.909c-8.922 0-16.155 7.233-16.155 16.155s7.233 16.155 16.155 16.155h15.909v15.909c0 8.922 7.233 16.155 16.155 16.155s16.155-7.233 16.155-16.155v-15.91h15.909c8.922 0 16.155-7.233 16.155-16.155s-7.233-16.154-16.155-16.154z",
    fill: "#f7ba4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.039 196.139h-20.725c-22.607 0-42.583-14.712-49.289-36.302l-4.756-15.31-16.92 27.236c-9.417 15.158-25.996 24.376-43.841 24.376h-51.462v-42.13c0-34.206 27.729-61.935 61.935-61.935h63.124c34.206 0 61.935 27.729 61.935 61.935v42.13z",
    fill: "#68748f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.978 92.08h30.967c-34.198 0-61.935 27.726-61.935 61.935v42.126h-30.967v-42.126c0-34.209 27.737-61.935 61.935-61.935z",
    fill: "#5d6980"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveThinking);
export default __webpack_public_path__ + "static/media/positive-thinking.3724018a8f78d465292cc3e7c1229bd1.svg";
export { ForwardRef as ReactComponent };